import { FC } from 'react'

import { useTranslation } from 'react-i18next'

// import { ButtonContinue } from 'shared/ui/bottom-continue'
import { HeaderGoBack } from 'shared/ui/header-go-back'

import {
  MInstalmentBanner,
  MInstalmentPros,
  MInstalmentTotal,
} from './components'
import s from './styles.module.scss'

interface Props {
  payNow?: string
  countMonth?: number
  monthlyPrice?: string
  onPaymentMInstalment?: () => void
}

export const MInstalmentDetail: FC<Props> = ({
  payNow,
  monthlyPrice,
  // onPaymentMInstalment,
}) => {
  const { t } = useTranslation()

  return (
    <div className={s.screen}>
      <HeaderGoBack title={t('minstallment.info_title')} />

      <MInstalmentBanner />

      <div className="container">
        <MInstalmentPros />

        <MInstalmentTotal
          payNow={payNow}
          monthlyPrice={monthlyPrice}
        />
      </div>

      {/* <ButtonContinue onClick={onPaymentMInstalment}>
        <span className="semi-bold-17">{t('minstallment.arrange')}</span>
      </ButtonContinue> */}
    </div>
  )
}
